import React, { useContext } from "react";
import { Button as StyledButton } from "./styled";
import { Context } from "./context";
import cls from "clsx";

type tProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  children: any;
};
const Button = (props: tProps) => {
  const { value, onChange } = useContext(Context);
  const isActive = value === props.value;
  return (
    <StyledButton
      disabled={props.disabled}
      onClick={() => onChange(props.value)}
      isActive={isActive}
      aria-pressed={isActive}
      tabIndex={0}
      className={cls("ripple-btn", props.className)}
      type="button"
    >
      {props.children}
    </StyledButton>
  );
};

export default Button;
